import { MainContext } from 'context/mainContext';
import React, { useContext } from 'react'

 function DashboardLoading() {
    const {
        bgColor
    } = useContext(MainContext);
    return (
        <div className='dashboardloading-container'>
            {/* <div class="boxes">
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="box">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div> */}

            <div className="cube-loader">
            <div className="cube cube1" style={{ background: bgColor }}></div>
            <div className="cube cube2" style={{ background: bgColor }}></div>
            <div className="cube cube3" style={{ background: bgColor }}></div>
            <div className="cube cube4" style={{ background: bgColor }}></div>
            </div>

        </div>
    );
}

export default DashboardLoading